export default __webpack_public_path__ + "static/media/meeting-note.4afd3ab8.png";